import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const UnifiedFooter = () => {
  return (
    <footer className="bg-green-900 text-white mt-12 md:mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mb-6 md:mb-8">
          {/* Column 1: ADT Express */}
          <div>
            <h3 className="text-lg md:text-xl font-bold mb-3 md:mb-4">ADT Express</h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              Votre partenaire de confiance pour l'expédition de colis entre la France et la Côte d'Ivoire depuis plus de 10 ans.
            </p>
          </div>

          {/* Column 2: Navigation */}
          <div>
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4">Navigation</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors inline-block py-1">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-gray-300 hover:text-white transition-colors inline-block py-1">
                  Tarifs
                </Link>
              </li>
              <li>
                <Link to="/tracking" className="text-gray-300 hover:text-white transition-colors inline-block py-1">
                  Suivi
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-white transition-colors inline-block py-1">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/shipping-information" className="text-gray-300 hover:text-white transition-colors inline-block py-1">
                  Qui sommes-nous
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Services */}
          <div>
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4">Services</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/client-login" className="text-gray-300 hover:text-white transition-colors inline-block py-1">
                  Espace Client
                </Link>
              </li>
              <li>
                <Link to="/professional-client-login" className="text-gray-300 hover:text-white transition-colors inline-block py-1">
                  Espace Professionnel
                </Link>
              </li>
              <li>
                <span className="text-gray-300 inline-block py-1">Barriques Noire & Bleue</span>
              </li>
              <li>
                <span className="text-gray-300 inline-block py-1">Cartons Triple Cannelure</span>
              </li>
              <li>
                <span className="text-gray-300 inline-block py-1">Livraison à domicile</span>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div>
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <Icon name="MapPin" size={16} className="flex-shrink-0 mt-1" color="white" />
                <span className="text-gray-300">23 rue de l'essonne 91000 evry</span>
              </li>
              <li className="flex items-start space-x-2">
                <Icon name="Phone" size={16} className="flex-shrink-0 mt-1" color="white" />
                <a href="tel:0651988621" className="text-gray-300 hover:text-white transition-colors">
                  06 51 98 86 21
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <Icon name="MessageCircle" size={16} className="flex-shrink-0 mt-1" color="white" />
                <a 
                  href="https://wa.me/33651988621" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  WhatsApp
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <Icon name="Mail" size={16} className="flex-shrink-0 mt-1" color="white" />
                <span className="text-gray-300">contact@adtexpress.fr</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-green-800 pt-6 md:pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-300 text-center md:text-left">
              © 2026 ADT Express — Tous droits réservés
            </p>
            <div className="flex items-center space-x-4 md:space-x-6 text-sm">
              <Link to="/mentions-legales" className="text-gray-300 hover:text-white transition-colors">
                Mentions légales
              </Link>
              <Link to="/cgv" className="text-gray-300 hover:text-white transition-colors">
                CGV
              </Link>
              <Link to="/politique-de-confidentialite" className="text-gray-300 hover:text-white transition-colors">
                Politique de confidentialité
              </Link>
            </div>
          </div>

          {/* Mention légale discrète */}
          <p className="mt-4 text-xs text-gray-500 text-center leading-relaxed">
            ADT EXPRESS est une marque exploitée par TRANSIMPEX INTERNATIONAL SERVICES, SASU immatriculée au RCS de Bobigny sous le numéro 990 952 806, dont le siège social est situé au 34 Rue Hémet, 93300 Aubervilliers.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default UnifiedFooter;